export const environment = {
  production: true,
  apiUrl: 'https://api.justteach.ai',
  sentryEnabled: true,
  amplitudeApiKey: 'f5ed7f4077f9f4d095cf2454c160f30b',
};

